<template>
    <b-container fluid class="filtroWebservice"> 
        <ModalLogDetalhes :datas="logDataModal" :pagination="LogsPage" :loading="loadingDetalhes" />

        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="fas fa-plug"></i> Webservice</span>
                <b-row>
                    <div class="col-lg-12 col-md-12 mt-2">
                        <container-card id="filtroWebservice" icon="fa-filter" title="Selecione as opções de webservice.">
                            <el-form v-loading="loadingWebservices" :model="model" :rules="rules" ref="formWebservice" size="mini" label-position="top">
                                <b-card>
                                    <b-form-row class="mb-2">
                                        <div class="col-lg-5 col-md-6">
                                            <b-form-row class="mb-0">
                                                <div class="col-lg-6 col-md-6">
                                                    <el-form-item label="Tipo de Webservice" prop="Tipo">
                                                        <select2 :options="listas.tipos" name="Tipo" v-model="model.Tipo" :url="$urls.OBTER_TIPOS_WEBSERVICE"></select2>
                                                    </el-form-item>
                                                </div>
                                                <div class="col-lg-6 col-md-6">
                                                    <el-form-item label="Data início/fim" prop="datas" required>
                                                        <el-date-picker v-model="model.datas"
                                                            type="daterange"
                                                            range-separator="|"
                                                            start-placeholder="Início"
                                                            end-placeholder="Fim"
                                                            format="dd/MM/yyyy"
                                                            size="small"
                                                            class="w-100">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </b-form-row>
                                        </div>
                                        <div class="col-lg-7 col-md-6 cluster-input">
                                            <el-form-item required label="Cluster de empresas:" label-for="empresasACluster" prop="ClusterId">
                                                <select2 :options="listas.cluster" name="empresasACluster" v-model="model.ClusterId" :url="$urls.DRE_LISTA_CLUSTER"></select2>
                                            </el-form-item>
                                        </div>
                                    </b-form-row>
                                    <b-form-row v-if="model.Tipo == '2'" class="mb-2">
                                        <div class="col-lg-6 col-md-6">
                                            <b-form-group id="modelodreValores" label="Modelo de DRE:" label-for="modeloDREValoresSelect" class="position-relative">
                                                <select2 required 
                                                    :options="listas.modelosDRE" 
                                                    name="modeloDREValoresSelect" 
                                                    v-model="model.ModeloDRE">
                                                </select2>
                                            </b-form-group>
                                            <message-validation :showError="model.Tipo == '2' && model.ModeloDRE == ''">Campo obrigatório</message-validation>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <b-form-group id="linhaValores" label="Linha da DRE:" label-for="linhaValoresSelect">
                                                <select2 required 
                                                    :options="listas.linhaDRE" 
                                                    name="linhaValoresSelect" 
                                                    v-model="model.LinhaDRE"
                                                    :refresh="true">
                                                </select2>
                                            </b-form-group>
                                            <message-validation :showError="model.Tipo == '2' && model.LinhaDRE == ''">Campo obrigatório</message-validation>
                                        </div>
                                    </b-form-row>
                                    <div slot="footer">
                                        <div class="float-left btn-pesquisar" v-if="temAcesso('Webservice','Obter')">
                                            <b-button style="width:100px;" @click.prevent="pesquisarWebservice" variant="primary" size="sm" class="mr-2">Pesquisar</b-button>
                                            <b-button style="width:100px;" @click.prevent="limpar" size="sm" class="mr-2">Limpar</b-button>
                                        </div>
                                        <div class="float-left btn-pesquisar" v-else>
                                            <b-button style="width:100px;" disabled size="sm" class="mr-2 no-drop" title="Sem permissões">Pesquisar</b-button>
                                        </div>
                                        <div class="float-right btn-pesquisar">
                                            <b-button style="width:150px;" v-if="temAcesso('Webservice','Criar')" @click.prevent="SolicitarWebservice" variant="success" size="sm" class="mr-2">Solicitar Webservice</b-button>
                                            <b-button style="width:150px;" v-else disabled size="sm" class="mr-2 no-drop" title="Sem permissões">Solicitar Webservice</b-button>
                                        </div>
                                    </div>
                                </b-card>
                            </el-form>
                        </container-card>
                        <div :class="showListLog ? 'd-block' : 'd-none'">
                            <container-card fixed id="LogsWebservice" icon="fa-th-list" title="Log de webservice.">
                                <b-card>
                                    <el-button 
                                        class="float-right btn-recarregar" 
                                        circle 
                                        v-loading="loadingWebservices"
                                        @click="listarWebservices"
                                        v-b-popover.hover.top="'Recarregar Logs de webservice'">
                                        <i class="fas fa-sync-alt"></i>
                                    </el-button>
                                    <!-- TABLE -->
                                    <el-table
                                        class="p-table"
                                        stripe
                                        border
                                        size="mini"
                                        v-loading="loadingWebservices"
                                        :data="tableDataWebservices"
                                        style="width: 100%">
                                        
                                        <el-table-column
                                            prop="cluster"
                                            label="Cluster"
                                            min-width="100"
                                        >
                                            <template slot-scope="scope" v-if="scope.row">
                                                {{ scope.row.cluster ? scope.row.cluster.nome : '' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="tipo"
                                            label="Tipo"
                                            min-width="100"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="inicio"
                                            label="Data inicial"
                                            min-width="180">
                                        </el-table-column>
                                        <el-table-column
                                            prop="fim"
                                            label="Data final"
                                            min-width="180">
                                            <!-- <template slot-scope="scope" v-if="scope.row">
                                                {{ scope.row.fim ? moment(scope.row.fim).format('DD/MM/YYYY') : '' }}
                                            </template> -->
                                        </el-table-column>
                                        <el-table-column
                                            prop="criadoEm"
                                            label="Criado em"
                                            min-width="180">
                                            <!-- <template slot-scope="scope" v-if="scope.row">
                                                {{ scope.row.criadoEm ? moment(scope.row.criadoEm).format('DD/MM/YYYY') : '' }}
                                            </template> -->
                                        </el-table-column>
                                        <el-table-column
                                            prop="status"
                                            label="Status"
                                            min-width="100"
                                        >
                                            <template slot-scope="scope">
                                                <span :style="scope.row.contemErro ? 'color: red' : 'color: green'">
                                                    {{ scope.row.status }}<span v-if="scope.row.contemErro"> (!)</span>
                                                </span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            label="Log completo"
                                            min-width="125"
                                            fixed="right"
                                        >
                                            <template slot-scope="scope" v-if="scope.row">
                                                <b-button variant="outline-secondary" size="sm" class="rounded-pill px-3 my-1" @click="mostrarLogsDetalhados(scope.row.callWebserviceFinancasId)">
                                                    Detalhes <i class="fas fa-eye"></i>
                                                </b-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-footer class="text-center" style="padding-top:13px;">
                                        <el-pagination
                                            class="text-center"
                                            background
                                            layout="prev, pager, next, sizes"
                                            @size-change="paginacaoSize"
                                            @current-change="paginacaoCurrent"
                                            :page-size="webserviceLog.perPage"
                                            :current-page.sync="webserviceLog.pageNumber"
                                            :total="webserviceLog.total"
                                            :page-sizes="[5, 10, 25, 50, 75, 100]">
                                        </el-pagination>
                                    </el-footer>
                                </b-card>
                            </container-card>
                        </div>
                    </div>
                </b-row>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="fas fa-key"></i> Chaves de API</span>
                <b-row>
                    <ChavesApi />
                </b-row>
            </el-tab-pane>
        </el-tabs>
    </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2 from '@/components/shared/Select2'
import ModalLogDetalhes from '@/views/Webservice/ModalLogDetalhes'
import ChavesApi from '@/views/Webservice/ChavesApi'

const listas = () => {
    return {
        modelosDRE: [],
        linhaDRE: [],
        cluster: [],
        tipos: []
    }
}

const model = () => {
    return {
        Inicio: '',
        Fim: '',
        datas: '',
        ClusterId: [],
        Tipo: '',
        ModeloDRE: '',
        LinhaDRE: ''
    }
}

export default {
    components: {
        ContainerCard,
        Select2,
        ModalLogDetalhes,
        ChavesApi
    },
    name: 'sincronizacao',
    data() {
        return {
            loadingWebservices: false,
            loadingDetalhes: false,
            model: model(),
            listas: listas(),
            tableDataWebservices: [],
            tableDataLogs: [],
            logDataModal: [],
            showListLog: false,
            rules: {
                datas: [
                    { required: true, message: 'Por favor, escolha um período', trigger: 'change' }
                ],
                ClusterId: [
                    { required: true, message: 'Por favor, escolha um cluster', trigger: 'change' }
                ]
            },
            webserviceLog: {
                pageNumber: 1,
                perPage: 50,
                total: 50
            },
            LogsPage: {
                page: 1,
                pageSize: 10
            },
        }
    },
    methods: {
        limpar() {
            this.model = model()
        },
        SolicitarWebservice() {
            this.loadingWebservices = true

            this.$refs['formWebservice'].validate((valid) => {
                if (!valid) {
                    this.loadingWebservices = false
                    return false;
                }

                this.solicitar()
            });
        },
        pesquisarWebservice() {
            this.loadingWebservices = true

            this.$refs['formWebservice'].validate((valid) => {
                if (!valid) {
                    this.loadingWebservices = false
                    return false;
                }

                this.listarWebservices()
            });
        },
        logErro() {
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
        },
        async solicitar() {
            const response = await this.axios.post(this.$urls.SOLICITAR_WEBSERVICE, this.model);

            this.loadingWebservices = false

            if(response.status !== 200) {
                this.logErro();
                return;
            }

            this.$notify({
                type: "success",
                title: 'webservice',
                message: 'Solicitação de webservice criada.'
            });

            this.listarWebservices();
        },
        async listarWebservices() {
            this.loadingWebservices = true;

            const response = await this.axios.post(this.$urls.LISTAR_CALLS, Object.assign(this.model, {
                Page: this.webserviceLog.pageNumber,
                PageSize: this.webserviceLog.perPage,
            }));
            
            if(response.status !== 200){
                this.logErro();
                this.loadingWebservices = false;
                return;
            }
            
            this.tableDataWebservices = response.data.webservicesFinancas;
            this.webserviceLog.pageNumber = response.data.page;
            this.webserviceLog.total = response.data.total;
            this.loadingWebservices = false;
            this.showListLog = true;
        },
        async obterDetalhe(id, filter) {
            this.loadingDetalhes = true;

            try {
                if (!filter)
                    filter = {};

                let params = {
                    ...this.LogsPage,
                    StatusResponse: filter.StatusResponse,
                    EmpresasIds: filter.EmpresasIds?.join(","),
                    Inicio: filter.Inicio,
                    Fim: filter.Fim
                };

                const response = await this.axios.get(`${this.$urls.DETALHES_CALL}/${id}`, { params: params } );
                
                if (response.status !== 200) {
                    throw new Error("Erro ao obter detalhes");
                }

                this.logDataModal = response.data;
                this.logDataModal.id = id;
                this.loadingDetalhes = false;
                this.$bvModal.show('modal-log-detalhado');
            } catch (error) {
                console.error("Erro na função obterDetalhe:", error);
                this.logErro();
            } finally {
                this.loadingDetalhes = false;
            }
        },
        mostrarLogsDetalhados(id){
            this.obterDetalhe(id);
        },
        paginacaoCurrent(val){
            this.webserviceLog.pageNumber = val
            this.listarWebservices();
        },
        paginacaoSize(val){
            this.webserviceLog.perPage = val
            this.webserviceLog.pageNumber = 1
            this.listarWebservices();
        },
        callListas(){
            // call ModeloDRE
            var defaultModeloDre = (dt) => {
                if(!dt){ return false }
                    this.listas.modelosDRE = dt

                    // Define modelo default 
                    dt.forEach((item) => {
                        if(item.default){
                            setTimeout(() => {
                                this.model.ModeloDRE = item.id
                            },100)
                            return false
                        }  
                        
                        this.model.ModeloDRE = ''
                    })
            }
            if(this.isNullOrEmpty(this.listas.modelosDRE)){
                this.axios.get(this.$urls.DRE_MODELOS).then((dt) => {
                    defaultModeloDre(dt.data)
                })
            }else{
                defaultModeloDre(this.listas.modelosDRE)
            }
        }
    },
    watch: {
        'model.datas': function(val) {
            let hasVal = !this.isNullOrEmpty(val);

            this.model.Inicio = hasVal ? this.moment(val[0]).format('YYYY-MM-DD') : ''
            this.model.Fim = hasVal ? this.moment(val[1]).format('YYYY-MM-DD') : ''
        },
        'model.ClusterId'() {
            this.$refs['formWebservice'].validateField('ClusterId');
        },
        'model.ModeloDRE': function(val){
            if (!this.temAcesso('DreValorManual', 'Obter'))
            return false;


            var self = this
            self.axios.get(`${self.$urls.DRE_LINHAS_VALORES_MANUAIS}?modeloDre=${val}`).then((dt) => {
                if(!dt){ 
                    self.listas.linhaDRE = []
                    return false 
                }
                self.listas.linhaDRE = dt.data
            })
        },
        'model.Tipo' : function(val) {
            if (val == "2" && !this.temAcesso('DreValorManual', 'Obter')) {
               this.model.Tipo = '';
               this.$message({
                        type: 'info',
                        message: 'Acesso inválido devido restrição de acesso na visualização de valores manuais da DRE'
                });  
            }
        }
    },
    computed: {
        tableLength(){
            return this.tableDataWebservices.length
        }
    },
    mounted() {
        this.$root.$on('paginationDetalheCurrent', (val) => {
            this.LogsPage.page = val.p;
            this.obterDetalhe(val.id, val.f);
        });
        this.$root.$on('paginationDetalheSize', (val) =>{
            this.LogsPage.pageSize = val.p;
            this.obterDetalhe(val.id, val.f);
        });
        this.$root.$on('filtrarLogs', (val) => {
            this.obterDetalhe(val.id, val.f);
        });
        this.callListas();
    }
}
</script>
<style>
.btn-recarregar {
    border-radius: 50%;
    padding: 12px;
    position: absolute;
    top: -39px;
    right: 10px;
}

/* fix estilos com form el */
.filtroSincronizacao .toogle-multiselect-cluster {
    top: -31px;
}
.filtroSincronizacao .el-form--label-top .el-form-item__label {
    padding: 0 0 0;
}
.filtroSincronizacao div span.select2-container .select2-search--inline .select2-search__field {
    margin: 0px 5px !important;
}
div.cluster-input span.select2-container .select2-search--inline .select2-search__field {
    margin: 0px 5px !important;
}
</style>